import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import SidebarItem from './item'
import SidebarItemCollapse from './itemCollapse'
import { Logo } from 'Components/Ui'
import { BiArrowBack } from 'react-icons/bi'

export default function Sidebar({ toUrl, appRoutes, sidebarOpen = true, setSidebarOpen, type = 0 }) {
    const sidebar = useRef(null)
    const { user } = useSelector(state => state.auth)

    const checkRoute = items => {
        if (!user) return items
        if (['user', 'store_user'].includes(user.guard)) {
            if (!user.authorize.includes(items.permission)) {
                if (!items.child) return false
                items.child = items.child.filter(e => checkRoute(e)).map(e => checkRoute(e))
                if (items.child.length <= 0) return false
            }
        }
        return items
    }

    const NavDiv = () => (
        <>
            {appRoutes
                .filter(e => checkRoute(e))
                .map(e => checkRoute(e))
                .map((route, index) => (
                    <div key={index}>
                        {type === 0 && <h3 className="mb-3 ml-3 text-sm font-semibold text-gray/50">{route.text}</h3>}
                        <ul className={`flex gap-1 ${type === 0 ? 'flex-col mb-3' : 'items-center'}`}>
                            {route.child.map((item, key) =>
                                item.child && item.child.length > 0 ? (
                                    <SidebarItemCollapse item={item} key={key} type={type} />
                                ) : (
                                    <SidebarItem item={item} key={key} type={type} />
                                )
                            )}
                        </ul>
                    </div>
                ))}
        </>
    )

    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (sidebarOpen && sidebar.current && !sidebar.current.contains(target) && window.innerWidth < 1024) {
                setSidebarOpen(false)
            }
        }
        document.addEventListener('click', clickHandler)
        return () => document.removeEventListener('click', clickHandler)
    })

    if (type === 1) return <NavDiv />

    return (
        <aside
            ref={sidebar}
            className={`absolute left-0 top-0 z-20 flex h-screen w-64 flex-col overflow-y-hidden bg-black duration-300 ease-linear dark:bg-boxdark ${
                sidebarOpen ? 'lg:static translate-x-0' : '-translate-x-full'
            }`}
        >
            <div className="flex items-center justify-between gap-2 px-6 py-4">
                <Link to={toUrl}>
                    <Logo />
                </Link>
                <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    aria-controls="sidebar"
                    aria-expanded={sidebarOpen}
                    className="block"
                >
                    <BiArrowBack size={25} />
                </button>
            </div>
            <div className="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
                <nav className="px-3 py-3">
                    <NavDiv />
                </nav>
            </div>
        </aside>
    )
}
